var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeUserWidget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "216px",
    height: "216px",
    viewBox: "0 0 216 216",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "377F3DA4-BA9E-4795-B487-2EF928A74A9C@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-account-\\u2705",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01C---My-Account---Free",
    transform: "translate(-79.000000, -427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(20.000000, 371.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(59.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0,
    fill: "#FFFFFF",
    cx: 108,
    cy: 108,
    r: 108
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF3DB",
    cx: 108,
    cy: 108,
    r: 68
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-149",
    transform: "translate(52.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.928571,113 L8.07142857,113 C3.61196429,113 0,109.388036 0,104.928571 L0,8.07142857 C0,3.61196429 3.61196429,0 8.07142857,0 L104.928571,0 C109.388036,0 113,3.61196429 113,8.07142857 L113,104.928571 C113,109.388036 109.388036,113 104.928571,113 L104.928571,113 Z",
    id: "Stroke-123",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0415584,101.161905 L19.9584416,101.161905 C15.4719502,101.161905 11.8380952,97.5843401 11.8380952,93.1673469 L11.8380952,81.1755102 C11.8380952,76.758517 15.4719502,73.1809524 19.9584416,73.1809524 L93.0415584,73.1809524 C97.5280498,73.1809524 101.161905,76.758517 101.161905,81.1755102 L101.161905,93.1673469 C101.161905,97.5843401 97.5280498,101.161905 93.0415584,101.161905 L93.0415584,101.161905 Z",
    id: "Stroke-125",
    stroke: "#17243D",
    strokeWidth: 2,
    fill: "#FFD67E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(23.676190, 81.790476)",
    stroke: "#17243D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 10.7619048,
    y2: 10.7619048,
    id: "Stroke-127"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10.7619048,
    x2: 10.7619048,
    y2: 0,
    id: "Stroke-129"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.5887446,
    y1: 0,
    x2: 29.3506494,
    y2: 10.7619048,
    id: "Stroke-131"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.5887446,
    y1: 10.7619048,
    x2: 29.3506494,
    y2: 0,
    id: "Stroke-133"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.1991342,
    y1: 0,
    x2: 46.961039,
    y2: 10.7619048,
    id: "Stroke-135"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.1991342,
    y1: 10.7619048,
    x2: 46.961039,
    y2: 0,
    id: "Stroke-137"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.7878788,
    y1: 0,
    x2: 65.5497835,
    y2: 10.7619048,
    id: "Stroke-139"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.7878788,
    y1: 10.7619048,
    x2: 65.5497835,
    y2: 0,
    id: "Stroke-141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(29.980952, 7.533333)",
    stroke: "#17243D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7333333,26.3666667 C52.7333333,40.9291795 40.9291795,52.7333333 26.3666667,52.7333333 C11.8041538,52.7333333 0,40.9291795 0,26.3666667 C0,11.8041538 11.8041538,-7.10542736e-15 26.3666667,-7.10542736e-15 C40.9291795,-7.10542736e-15 52.7333333,11.8041538 52.7333333,26.3666667 L52.7333333,26.3666667 Z",
    id: "Stroke-147",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3666667,32.5306862 C34.7918308,32.5306862 42.1177077,37.215105 45.9145077,44.1238095 C50.1412872,39.4353244 52.7333333,33.2463613 52.7333333,26.4311826 C52.7333333,11.8330371 40.9291795,-7.10542736e-15 26.3666667,-7.10542736e-15 C11.8041538,-7.10542736e-15 0,11.8330371 0,26.4311826 C0,33.2463613 2.59204615,39.4353244 6.81882564,44.1238095 C10.6156256,37.215105 17.9415026,32.5306862 26.3666667,32.5306862 L26.3666667,32.5306862 Z",
    id: "Stroke-145",
    fill: "#25D086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5904762,22.0619048 C36.5904762,27.7095371 32.014299,32.2857143 26.3666667,32.2857143 C20.7190343,32.2857143 16.1428571,27.7095371 16.1428571,22.0619048 C16.1428571,16.4142724 20.7190343,11.8380952 26.3666667,11.8380952 C32.014299,11.8380952 36.5904762,16.4142724 36.5904762,22.0619048 L36.5904762,22.0619048 Z",
    id: "Stroke-143",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-394",
    transform: "translate(71.500000, 4.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,14.5 C29,22.508 22.508,29 14.5,29 C6.492,29 0,22.508 0,14.5 C0,6.492 6.492,0 14.5,0 C22.508,0 29,6.492 29,14.5 L29,14.5 Z",
    id: "Stroke-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFD67E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    fill: "#FFFFFF",
    points: "14.5 5 17 11 24 11 18.125 15.625 20 22.5 14.5 19 9 22.5 10.625 15.625 5 11 12 11"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F1F2F4",
    cx: 108,
    cy: 206,
    rx: 50,
    ry: 10
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeUserWidget);
export default __webpack_public_path__ + "static/media/free-user-widget.5c51467af9c870aa457175a46f891f59.svg";
export { ForwardRef as ReactComponent };